import type { CustomerStatus } from "./customersApi";

export const CUSTOMER_STATUS_VALUES: CustomerStatus[] = [
  "to check",
  "no interest",
  "cold",
  "warm",
  "lead",
  "active lead",
  "active",
  "adult",
];
